<template>
  <div class="preview-baseline-image">
    <div v-if="isLoading" class="text-center py-4">
      <a-icon type="sync" spin />
      <span class="ml-2">Loading baseline screenshot...</span>
    </div>

    <div v-else-if="error" class="error-state">
      <a-alert type="error" showIcon>
        <template slot="message">
          {{ error }}
        </template>
      </a-alert>
      <a-button type="primary" size="small" class="mt-3" @click="loadScreenshot">
        Retry
      </a-button>
    </div>

    <div v-else class="image-viewer">
      <div class="image-content">
        <img :src="screenshot" alt="Baseline screenshot" />
      </div>
    </div>
  </div>
</template>

<script>
import WebpageService from '../services/webpage.service';
import {
  BASELINE_SCREENSHOT_LOAD_FAILED,
  BASELINE_SCREENSHOT_MISSING,
  BASELINE_SCREENSHOT_NOT_FOUND,
} from '../consts/Webpage.consts';

export default {
  name: 'PreviewBaselineImage',
  props: {
    urlId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      error: null,
      screenshot: '',
    };
  },
  mounted() {
    this.loadScreenshot();
  },
  methods: {
    responseStatus(err) {
      if (!err) {
        return null;
      }
      if (err.status) {
        return err.status;
      }
      return err.response && err.response.status;
    },
    screenshotLoadError(err) {
      if (err && Array.isArray(err.messages) && err.messages[0]) {
        return err.messages[0];
      }
      return BASELINE_SCREENSHOT_LOAD_FAILED;
    },
    async loadScreenshot() {
      this.isLoading = true;
      this.error = null;
      this.screenshot = '';
      try {
        const data = await WebpageService.getImagesAnalytics(this.urlId);
        if (data && data.screenshot) {
          this.screenshot = data.screenshot;
        } else {
          this.error = BASELINE_SCREENSHOT_MISSING;
        }
      } catch (err) {
        console.error('Failed to load baseline screenshot:', err);
        if (this.responseStatus(err) === 404) {
          this.error = BASELINE_SCREENSHOT_NOT_FOUND;
        } else {
          this.error = this.screenshotLoadError(err);
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-baseline-image {
  min-height: 400px;
}

.error-state {
  padding: 20px;
  text-align: center;
}

.image-viewer {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
  background: #ffffff;
}

.image-content {
  overflow: auto;
  padding: 16px;
  background-color: #e8e8e8;
  max-height: 600px;
  text-align: center;

  img {
    max-width: 100%;
    height: auto;
    display: inline-block;
    border: 1px solid #d9d9d9;
    background: #fff;
  }
}
</style>
